/**
 * 反调试配置
 */

export const ANTI_DEBUG_CONFIG = {
  // 是否启用反调试
  enabled: false,
  
  // 反调试模式: 'mobile-friendly' | 'gentle' | 'simple' | 'advanced'
  mode: 'mobile-friendly' as 'mobile-friendly' | 'gentle' | 'simple' | 'advanced',
  
  // 是否在开发环境禁用反调试
  disableInDev: true,
  
  // 检测间隔（毫秒）
  checkInterval: 1000,
  
  // 是否启用随机检测
  randomCheck: true,
  
  // 崩溃方式: 'redirect' | 'crash' | 'clear'
  crashMethod: 'redirect' as 'redirect' | 'crash' | 'clear',
  
  // 移动端特有配置
  mobile: {
    // 是否启用移动端长按检测
    enableLongPress: true,
    
    // 是否启用移动端摇晃检测
    enableShake: true,
    
    // 是否启用移动端手势检测
    enableGestures: true,
    
    // 长按时间阈值（毫秒）
    longPressThreshold: 2000,
    
    // 摇晃检测阈值
    shakeThreshold: 15,
    
    // 摇晃次数阈值
    shakeCountThreshold: 5,
  }
}

// 检查是否在开发环境
function isDevelopment() {
  return import.meta.env.DEV || 
         window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' ||
         window.location.hostname.includes('dev') ||
         window.location.hostname.includes('test');
}

// 获取反调试配置
export function getAntiDebugConfig() {
  const config = { ...ANTI_DEBUG_CONFIG };
  
  // 如果在开发环境且配置了禁用，则禁用反调试
  if (config.disableInDev && isDevelopment()) {
    config.enabled = false;
  }
  
  return config;
}
